import { APIResponse } from '../../../../@types/api-response';
import { maintenanceEndpoint } from '../constants/apiEndpoint';
import { MaintenanceStatusResponse } from '../types/api/maintenance';
import { getTradingApiInstance } from './instance/trading';

export const getMaintenanceStatus = async (): Promise<
  APIResponse<MaintenanceStatusResponse>
> =>
  getTradingApiInstance().get(maintenanceEndpoint.getStatus, {
    withAccessToken: false,
  });
